import 'unpoly'

import { inTestEnvironment } from 'shared/javascripts/util/environment'
import { getCsrfParam, getCsrfToken } from 'shared/javascripts/util/csrf'
import { registerAssetDriftHandler } from 'frontend/unpoly/javascripts/util/unpoly_asset_drift'
import { registerInertiaPageHandler } from 'frontend/unpoly/javascripts/util/unpoly_inertia_pages'
import { inertiaFormSelectors, inertiaLinkSelectors } from 'shared/javascripts/util/inertia_paths'

function buildImageExtension() {
  // We need a own img element to set object-fit and object-position. Using a ::after element on up-modal-box was
  // limited to set these properties.
  const image = document.createElement('img')
  image.alt = 'Studyflix'

  const imageExtenstionContainer = document.createElement('div')
  imageExtenstionContainer.classList.add('up-modal-image-extension')
  imageExtenstionContainer.appendChild(image)

  return imageExtenstionContainer
}

up.on('up:layer:opened', function (event) {
  if (event.layer.mode === 'modal') {
    const upModalViewport = event.layer.element.querySelector<HTMLElement>('up-modal-viewport')!
    const upModalBox = event.layer.element.querySelector<HTMLElement>('up-modal-box')!
    const modalLayoutContainer = up.element.affix(
      upModalViewport,
      'afterbegin',
      '.up-modal-viewport-extension',
    )

    upModalBox.appendChild(buildImageExtension())

    // To justify the content vertically and allow scrolling requires a wrapper class. Otherwise the modal was cut off
    // on the top for smaller screens or had a scrollbar on the up-modal-content
    modalLayoutContainer.appendChild(upModalBox)
  }
})

up.script.config.scriptElementPolicy = 'block'
up.script.config.evalCallbackPolicy = 'nonce'
up.layer.config.modal.dismissARIALabel = 'Schließen'
up.layer.config.modal.dismissLabel = '' // We set the close icon manually from an SVG image
up.layer.config.overlay.class = 'default-modal'
up.link.config.followSelectors.push('a[href]')
up.link.config.instantSelectors.push('a[href]')
up.link.config.preloadSelectors.push('a[href]')
up.form.config.submitSelectors.push('form')
up.link.config.noFollowSelectors.push(...inertiaLinkSelectors())
up.link.config.noFollowSelectors.push('a[href^="/admin"]')
up.form.config.noSubmitSelectors.push(...inertiaFormSelectors())
up.form.config.noSubmitSelectors.push('[data-up-submit="false"]')
up.form.config.watchInputDelay = 100
up.link.config.preloadDelay = 140
up.protocol.config.csrfParam = getCsrfParam
up.protocol.config.csrfToken = getCsrfToken
up.network.config.progressBar = true
up.network.config.lateDelay = 800
up.viewport.config.revealSnap = 100
up.on('up:fragment:poll', (event) => {
  if (document.body.dataset.polling !== 'true') event.preventDefault()
})
up.status.config.currentClasses = ['-active']

up.fragment.config.autoHistoryTargets.push('[up-set-history]')
up.history.config.restoreTargets.unshift('[up-history-restore]') // see up_history_restore compiler

up.fragment.config.navigateOptions.cache = false
up.fragment.config.navigateOptions.revalidate = false

if (inTestEnvironment()) {
  up.link.config.preloadDelay = 10 * 1000
  up.motion.config.enabled = false
  up.network.config.concurrency = 1
}

/**
 * Please don't "simplify" the following lines, otherwise vite won't strip them
 * This banner clutters the Google-Crawler Log messages, which makes it harder see crawling errors in production.
 */
if (process.env.NODE_ENV === 'production') {
  up.log.config.banner = false
}

if (process.env.NODE_ENV === 'development') {
  up.log.config.banner = true
}

up.on('up:fragment:loaded', async function (event) {
  const newNavbarStyle = event.response.header('X-Navbar-Style')
  const currentNavbarStyle = document.body.dataset.navbarStyle
  if (newNavbarStyle !== currentNavbarStyle && !event.renderOptions.target) {
    event.renderOptions.target = 'body'
  }
})

registerAssetDriftHandler()
registerInertiaPageHandler()
